import WYSIWYG from '@components/ui/WYSIWYG'

interface Props {
  slice: any
}

const TradeAccountsStaticText = ({ slice }: Props) => {
  const title = slice?.primary?.title
  const description = slice?.primary?.description
  const advantagesTitle = slice?.primary?.advantagesTitle
  const advantagesList = slice?.primary?.advantagesList
  const signYouUpText = slice?.primary?.signYouUpText
  const titleAlignment =
    slice?.primary?.title_alignment === 'left' ? 'text-left' : 'text-center'
  const descriptionAlignment =
    slice?.primary?.description_alignment === 'left'
      ? 'text-left'
      : 'text-center'
  const advantagesTitleAlignment =
    slice?.primary?.advantages_title_alignment === 'left'
      ? 'text-left'
      : 'text-center'
  const advantagesListAlignment =
    slice?.primary?.advantages_list_alignment === 'left'
      ? 'text-left'
      : 'text-center'
  const signYouUpTextAlignment =
    slice?.primary?.sign_you_up_text_alignment === 'left'
      ? 'text-left'
      : 'text-center'
  return (
    <div className="wrapper grid grid-cols-12 gap-2 overflow-hidden">
      <div className="col-span-12 col-start-1 flex flex-col items-center justify-center text-center lg:col-span-4 lg:col-start-5">
        <div className="items-center">
          {title && (
            <h1
              className={`heading-mobile-3 lg:heading-3 w-full whitespace-nowrap ${titleAlignment}`}
            >
              {title}
            </h1>
          )}
          {description && (
            <p className={`body-1 w-full pt-4 ${descriptionAlignment}`}>
              {description}
            </p>
          )}
        </div>
        {advantagesTitle && (
          <p className={`body-1 flex w-full pt-10 ${advantagesTitleAlignment}`}>
            {advantagesTitle}
          </p>
        )}
        {advantagesList && (
          <div
            className={`tradeAccounts w-full pt-2 ${advantagesListAlignment}`}
          >
            <WYSIWYG content={advantagesList} />
          </div>
        )}
        {signYouUpText && (
          <p className={`body-1 w-full pt-8 ${signYouUpTextAlignment}`}>
            {signYouUpText}
          </p>
        )}
      </div>
      <style jsx global>
        {`
          .tradeAccounts .wysiwyg ul li {
            padding-bottom: 8px;
          }
        `}
      </style>
    </div>
  )
}

export default TradeAccountsStaticText
